var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontChest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 62,
    viewBox: "0 0 47 62",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.809 57.9828V52.6522C43.809 48.8764 44.7924 40.1095 45.1203 39.1688C45.3691 38.4549 46.1037 36.8693 46.4315 36.3467C46.4315 36.3467 41.5236 31.2439 41.4965 17.8903C41.4774 8.48764 43.6049 1.37696 44.1413 0.576172C43.165 1.08636 36.5969 3.85437 22.8285 3.85437C9.06006 3.85437 3.16381 0.576172 3.16381 0.576172M43.809 58.3107C43.809 58.3107 31.7144 60.9406 23.4841 60.895C15.602 60.8514 3.81494 57.9828 3.81494 57.9828V52.6522C3.81494 48.8764 2.83148 40.1095 2.50366 39.1688C2.25486 38.4549 1.5202 36.8693 1.19238 36.3467C1.19238 36.3467 5.41092 32.0424 5.40976 19.1444C5.4089 9.52024 3.61371 1.70195 3.16907 0.881348",
    stroke: "#202E5F",
    strokeWidth: 0.65564,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontChest);
export default __webpack_public_path__ + "static/media/FrontChest.e231ae85d92c839bc9d4212ebb790c98.svg";
export { ForwardRef as ReactComponent };